import { Close, HelpOutline } from '@mui/icons-material';
import {
  Box,
  Drawer,
  IconButton,
  Typography,
  Divider,
} from '@mui/material';
import React from 'react';

interface HelpSlideoutProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const HelpSlideout: React.FC<HelpSlideoutProps> = ({
  open,
  onClose,
  children,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 400 },
          p: 3,
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <HelpOutline color="primary" />
          <Typography variant="h6">Help</Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </Box>
      <Divider sx={{ mb: 3 }} />
      <Box>{children}</Box>
    </Drawer>
  );
};

export default HelpSlideout;
